'use client';

import { d } from '@tanstack/react-query-devtools/build/legacy/devtools-PtxSnd7z';

import { Image } from '../Image';
import { useTranslations } from 'next-intl';

import { PromoCodeResult } from '@/api/types/user.types';

import styles from '@/components/PromoCodeModal/SuccessPromoCodeContainer.module.scss';

// =================================================================

const ASPECT_RATIO = 281 / 250;

// =================================================================

export interface SuccessPromoCodeContainerProps {
  promoCodeResponse?: PromoCodeResult[];
}

export const SuccessPromoCodeContainer = (props: SuccessPromoCodeContainerProps) => {
  const { promoCodeResponse = [] } = props;
  const t = useTranslations('page.userProfile.promoCodes');
  return (
    <div className={styles.successPromoCodeContainer}>
      <Image
        alt="prize image"
        aspectRatio={ASPECT_RATIO}
        src={'/assets/images/prize.png'}
        width={281}
        height={250}
      />
      <h2 className={styles.title}>{t('congratulations')}</h2>
      <p className={styles.description}>
        {t('congratulationsDescription', {
          period: promoCodeResponse[0]?.days === 30 ? t('monthly') : t('annual'),
          tariff: promoCodeResponse[0]?.tariff_title,
        })}
      </p>
    </div>
  );
};
